import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { AuthState } from './types';
import { initialState } from './initial-state';

const slice = createSlice({
  name: 'authSession',
  initialState,
  reducers: {
    setSessionCredentials: (state, { payload }: PayloadAction<AuthState>) => {
      return { ...state, ...payload };
    },
    clearSessionCredentials: (_state) => {
      return initialState;
    },
  },
});

export const { setSessionCredentials, clearSessionCredentials } = slice.actions;

export const selectSessionAccessToken = (state: RootState) =>
  state.authSession.accessToken;

export default slice.reducer;
